import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import Table from './ClientProfileTable';
import Pagination from '../../CustomControls/Pagination';
import { getAllClientProfiles, setOnConfirmationModal, deleteClientProfile } from '../../../store/actions/Master/clientProfile';
import LoadingSpinner from '../../CustomControls/Spinner';
import Notification from '../../CustomControls/Notification';
import Breadcrumbs from '../../CustomControls/Breadcrumb';
import CustomConfirmation from '../../CustomControls/ConfirmationModal';
import { _create, _clientprofile, _delete, _clientadmin, _view } from '../../../constants/componentConstants';
import { hasPermissionToAction } from '../../../utils/accessUtil';
import SearchBar from '../../CustomControls/SearchBar';

import './style.scss';

const ClientProfiles = props => {
  const [searchText, setSearchText] = useState('');

  const [results, setResults] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const clientProfile = useSelector(state => state.clientProfile);
  const ui = useSelector(state => state.ui);
  const pageSize = ui.layout.pageSize;
  const permissions = ui.layout.permissions;

  const notificationType = clientProfile.isError ? 'error' : 'success';

  const showSaveOption = hasPermissionToAction(permissions, _clientprofile, _create);
  const showDeleteOption = hasPermissionToAction(permissions, _clientprofile, _delete);

  useEffect(() => {
    dispatch(getAllClientProfiles());
  }, [dispatch]);

  useEffect(() => {
    if (searchText.length > 0) {
      setResults(
        clientProfile.clientProfileList.filter(
          x =>
            x.clientCode.toLowerCase().includes(searchText.toLowerCase()) ||
            x.clientName.toLowerCase().includes(searchText.toLowerCase()) ||
            x.abn.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setResults(clientProfile.clientProfileList);
    }
  }, [searchText, setResults, clientProfile.clientProfileList]);

  const onPageChangeHandler = currentPage => {};

  const onAddNewHandler = () => {
    history.push('/master/client-profiles/client-profile');
  };

  const onEditHandler = id => {
    history.push(`/master/client-profiles/client-profile/${id}`);
  };

  const breadCrumbPaths = [
    { id: 1, title: 'Home', path: '/' },
    { id: 2, title: `${hasPermissionToAction(permissions, _clientadmin, _view) ?  "User Listing" : "Client Listing"}`, path: '/master/client-profiles', isCurrent: true }
  ];

  const handleInput = e => {
    setSearchText(e.target.value);
  };

  const onDeleteHandler = id => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: true,
          confirmationId: id
        }
      })
    );
  };

  const onDeleteConfirmation = () => {
    if (clientProfile.confirmationId) {
      dispatch(deleteClientProfile(clientProfile.confirmationId));
    }
  };

  const onDeleteCancel = () => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: false,
          confirmationId: ''
        }
      })
    );
  };

  return (
    <React.Fragment>
      <CustomConfirmation
        show={clientProfile.showConfirmationModal}
        onDeleteClick={onDeleteConfirmation}
        onCloseClick={onDeleteCancel}
        message="Are you sure you want to delete this record?"
        header="Deleting record"
      />
      <div className="page-content">
        {clientProfile.showMessage && <Notification notificationType={notificationType} message={clientProfile.message} />}
        <Container fluid>
          <Breadcrumbs title={hasPermissionToAction(permissions, _clientadmin, _view) ?  "User Listing" : "Client Listing"} paths={breadCrumbPaths} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row className="mb-2 buttonrow">
                    <Col sm="4">
                      <SearchBar onChange={handleInput} placeholder="Search" value={searchText} />
                    </Col>
                    <Col sm="8">
                      <div className="text-sm-end">
                        {showSaveOption && (
                          <Button type="button" className="btn btn-primary btn-block  app-add-button" onClick={onAddNewHandler}>
                            {hasPermissionToAction(permissions, _clientadmin, _view) ?  "ADD USERS" : "ADD CLIENT"}
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="tablerow">
                    <Col xl="12">
                      <div>
                        {clientProfile.isLoading && <LoadingSpinner />}
                        <Pagination data={results} pageSize={pageSize} onPageChange={onPageChangeHandler} startingPage={1}>
                          <Table editHandler={onEditHandler} deleteHandler={onDeleteHandler} showDelete={showDeleteOption} />
                        </Pagination>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ClientProfiles;
